"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroBanner = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var clsx_1 = __importDefault(require("clsx"));
var prop_types_1 = __importDefault(require("prop-types"));
var useStyles = styles_1.makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});
var HeroBannerRender = function (props, ref) {
    var classes = props.classes, divider = props.divider, limit = props.limit, otherDivProps = __rest(props, ["classes", "divider", "limit"]);
    var defaultClasses = useStyles(props);
    var isArray = Array.isArray(props.children);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", __assign({ ref: ref, className: clsx_1.default(defaultClasses.root, classes.root) }, otherDivProps),
            props.children &&
                isArray &&
                props.children.slice(0, limit).map(function (child) { return child; }),
            props.children && !isArray && react_1.default.createElement(react_1.default.Fragment, null, props.children)),
        divider && react_1.default.createElement(Divider_1.default, null)));
};
/**
 * [HeroBanner](https://pxblue-components.github.io/react/?path=/info/components-hero--get-read-me-story) component
 *
 * The `<HeroBanner>` component is a simple wrapper component that is used to contain `<Hero>`s. It creates the flex container and sets up the spacing rules to display them. It accepts up to four `<Hero>` components as its children.
 */
exports.HeroBanner = react_1.default.forwardRef(HeroBannerRender);
exports.HeroBanner.displayName = 'HeroBanner';
exports.HeroBanner.propTypes = {
    classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
    }),
    divider: prop_types_1.default.bool,
    limit: prop_types_1.default.number,
};
exports.HeroBanner.defaultProps = {
    classes: {},
    divider: false,
    limit: 4,
};
